import { useCallback, useEffect, useState } from 'react';
import { listClosureEmployees, getPayrollClosure } from '../api/liquidacionApi';

function extractPayload(res) {
  if (!res) return null;
  return res.data !== undefined ? res.data : res; 
}

export function useClosureAccountingData(closureId) {
  const [closure, setClosure] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchAll = useCallback(async (id) => {
    if (!id) return;
    setLoading(true);
    setError('');

    try {
      const [listRes, closureRes] = await Promise.all([
        listClosureEmployees(id),
        getPayrollClosure(id),
      ]);

      setClosure(extractPayload(closureRes));
      
      const body = extractPayload(listRes);
      const employeesArray = Array.isArray(body?.data) 
        ? body.data 
        : (Array.isArray(body) ? body : []);

      setEmployees(employeesArray);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setClosure(null);
    setEmployees([]);
    setError('');

    if (closureId) {
      fetchAll(closureId);
    }

    return () => {
      setEmployees([]);
      setClosure(null);
    };
  }, [closureId, fetchAll]);

  return { closure, employees, loading, error, refetch: () => fetchAll(closureId) };
}